// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { PublicApi } from '@digitalasset/allocation-api-ts-client';
import React, { useContext } from 'react';

export const AllocationApiContext = React.createContext<PublicApi | undefined>(undefined);

export const useAllocationApiClient: () => PublicApi = () => {
  const client = useContext<PublicApi | undefined>(AllocationApiContext);
  if (!client) {
    throw new Error('Allocation client not initialized');
  }
  return client;
};
